import { Component } from 'react';
import { connect } from 'react-redux';
import I18n from 'I18n';
import styled from 'styled-components';
import SanitizedLabel from 'ContentComponents/cmv2/SanitizedLabel';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { FormLabel } from 'foundations-components/transitional/components/FormLabel';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import UIHoverlay from 'UIComponents/overlay/UIHoverlay';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { updateSelectedNavItem } from '../../actions/TemplateEditorNavigationActions';
import { getGradientSecondaryColor, getLinearGradientStyle, NAV_ITEMS } from 'knowledge-content-ui/constants/TemplateEditorConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BASE_I18N_KEY = `knowledgeContentUI.templateEditor.fields.headerBackgroundPreview`;
const OuterContainer = styled.div.withConfig({
  displayName: "HeaderBackgroundPreviewField__OuterContainer",
  componentId: "efm0t5-0"
})(["border:1px dashed #516f90;border-radius:3px;padding:30px 0;"]);
const HeaderBackgroundGradient = styled.img.withConfig({
  displayName: "HeaderBackgroundPreviewField__HeaderBackgroundGradient",
  componentId: "efm0t5-1"
})(["background-color:", ";background-image:", ";display:block;height:128px;width:100%;"], props => props.backgroundColor, props => props.backgroundImage);
const HeaderBackgroundPattern = styled.img.withConfig({
  displayName: "HeaderBackgroundPreviewField__HeaderBackgroundPattern",
  componentId: "efm0t5-2"
})(["background-color:", ";background-image:url(", ");background-size:auto 50%;display:block;height:128px;width:100%;"], props => props.color, props => props.patternUrl);
const HeaderBackgroundImage = styled.img.withConfig({
  displayName: "HeaderBackgroundPreviewField__HeaderBackgroundImage",
  componentId: "efm0t5-3"
})(["background-color:", ";display:block;height:auto;max-width:100%;"], props => props.color);
const HeaderBackground = props => {
  const {
    color,
    backgroundGradientType,
    backgroundImageSrc,
    backgroundPatternSrc,
    themeType
  } = props;
  if (backgroundImageSrc) {
    return /*#__PURE__*/_jsx(HeaderBackgroundImage, {
      color: color,
      src: backgroundImageSrc
    });
  }
  if (backgroundGradientType) {
    return /*#__PURE__*/_jsx(HeaderBackgroundGradient
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    , {
      backgroundColor: getGradientSecondaryColor(backgroundGradientType, themeType),
      backgroundImage: getLinearGradientStyle(backgroundGradientType, color)
    });
  }
  return (
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    _jsx(HeaderBackgroundPattern, {
      color: color,
      patternUrl: backgroundPatternSrc
    })
  );
};
const ChangeHeaderBackgroundButton = props => {
  return /*#__PURE__*/_jsx(UIHoverlay, {
    foregroundContent: /*#__PURE__*/_jsx(TFlex, {
      align: "center",
      justify: "center",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: `${BASE_I18N_KEY}.changeBackground`
      })
    })
    // @ts-expect-error ts-migrate(2769) FIXME: No overload matches this call.
    ,
    focused: props.disabled ? false : undefined,
    hovered: props.disabled ? false : undefined,
    onClick: props.onClick,
    children: /*#__PURE__*/_jsx(OuterContainer, {
      children: /*#__PURE__*/_jsx(HeaderBackground, {
        color: props.color,
        backgroundGradientType: props.backgroundGradientType,
        backgroundImageSrc: props.backgroundImageSrc,
        backgroundPatternSrc: props.backgroundPatternSrc,
        themeType: props.themeType
      })
    })
  });
};
class HeaderBackgroundPreviewField extends Component {
  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'headerBackground' does not exist on type... Remove this comment to see the full error message
      headerBackground: {
        color,
        backgroundGradientType,
        backgroundImageSrc,
        backgroundPatternSrc
      },
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'readOnly' does not exist on type 'Readon... Remove this comment to see the full error message
      readOnly,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'themeType' does not exist on type 'Reado... Remove this comment to see the full error message
      themeType
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsxs(FormLabel, {
        marginBlockStart: "800",
        children: [/*#__PURE__*/_jsx(SanitizedLabel, {
          label: I18n.text('knowledgeContentUI.templateEditor.fields.headerBackground.label')
        }), /*#__PURE__*/_jsx(HelpIcon, {
          title: I18n.text('knowledgeContentUI.templateEditor.fields.headerBackground.helpText'),
          tooltipPlacement: "top",
          marginInlineStart: "200"
        })]
      }), /*#__PURE__*/_jsx(ChangeHeaderBackgroundButton, {
        color: color,
        backgroundGradientType: backgroundGradientType,
        backgroundImageSrc: backgroundImageSrc,
        backgroundPatternSrc: backgroundPatternSrc,
        onClick: readOnly ? null : () => this.props.updateSelectedNavItem(NAV_ITEMS.HEADER_BACKGROUND),
        themeType: themeType,
        disabled: readOnly
      })]
    });
  }
}
const mapStateToProps = state => {
  const {
    templateSettings
  } = state;
  const {
    headerBackground = {}
  } = templateSettings.get('knowledgeBaseSettings');
  const {
    theme_type: themeType
  } = templateSettings.get('themeSettings');
  return {
    headerBackground,
    themeType
  };
};
const mapDispatchToProps = {
  updateSelectedNavItem
};
export default connect(mapStateToProps, mapDispatchToProps)(HeaderBackgroundPreviewField);